import { ErrorMessage } from "../../shared/infrastructure/ErrorMessageEnum";
import { ErrorCode } from "../../shared/infrastructure/ErrorCodeEnum";

export const SET_ERROR_MESSAGE: Record<ErrorCode, string> = {
  [ErrorCode.WCH006]: ErrorMessage.WCH006,
  [ErrorCode.DEFAULT]: ErrorMessage.CASH,
};
